import type { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { isNotNull, isNotUndefined } from '@hcr/utils'

import { useEarliestHoliday, useHoliday } from '../../../../contexts'
import { useAccommodationDetailsQuery, useDestinationDetailsQuery, useIdToken } from '../../../../hooks'
import { useTicketsCount } from '../../../../hooks/common'
import { DateFormat } from '../../../../models/i18n'
import { createAccommodationTicketsTotalCount } from '../../../../utils/components'
import { dateFormatter } from '../../../../utils/dates'
import { BookingOverviewHeroCard } from '../common'

import { BookingOverviewHomeLoading } from './BookingOverviewHomeLoading'

export const BookingOverviewHome: FC = () => {
  const { t } = useTranslation()
  const idToken = useIdToken()
  const holiday = useEarliestHoliday()
  const { setAccommodationId } = useHoliday()

  const accommodation = useAccommodationDetailsQuery(
    { idToken: String(idToken), accommodationId: Number(holiday.data.accommodationId) },
    { enabled: isNotNull(holiday.data.accommodationId) && isNotNull(idToken) }
  )

  const destinationDetails = useDestinationDetailsQuery(
    { destinationId: String(holiday.data.destinationId) },
    { enabled: isNotNull(holiday.data.destinationId) }
  )

  const ticketsCount = useTicketsCount()

  if (holiday.isSuccess && accommodation.isSuccess && isNotUndefined(destinationDetails.data)) {
    const totalTickets = createAccommodationTicketsTotalCount(ticketsCount, accommodation.data)
    const accommodationId = accommodation.data.accommodation_id

    return (
      <BookingOverviewHeroCard
        title={t('booking-overview.your-vacation-is-approaching')}
        linkLabel={t('booking-overview.view-reservation')}
        onLinkClick={() => setAccommodationId(accommodationId)}
        ticketsCount={ticketsCount}
        totalTickets={totalTickets}
      >
        {destinationDetails.data.name}{' '}
        {dateFormatter.formatDestinationDate(DateFormat.DayOfTheWeekShort, accommodation.data.start_date)}{' '}
        {dateFormatter.formatDestinationDate(DateFormat.Basic, accommodation.data.start_date)} -{' '}
        {dateFormatter.formatDestinationDate(DateFormat.DayOfTheWeekShort, accommodation.data.end_date)}{' '}
        {dateFormatter.formatDestinationDate(DateFormat.Basic, accommodation.data.end_date)}
      </BookingOverviewHeroCard>
    )
  }

  return <BookingOverviewHomeLoading />
}
